import { getString } from "../../common/common";

export const HS_TITLE = "HS_TITLE";
export const HS_P1 = "HS_P1";
export const HS_P2 = "HS_P2";
export const HS_P3 = "HS_P3";
export const GAPK_TITLE = "GAPK_TITLE";
export const GAPK_P1 = "GAPK_P1";
export const BOK_TITLE = "BOK_TITLE";
export const BOK_P1 = "BOK_P1";
export const BOK_P2 = "BOK_P2";
export const RSO_TITLE = "RSO_TITLE";
export const PS_TITLE = "PS_TITLE";
export const PS_P1 = "PS_P1";

export const translations = {
  en: {
    [HS_TITLE]: "History of KSRTC",
    [HS_P1]: `In order to cater to the transport needs of the travelling public of the
    then state of Mysore, Mysore Government Road Transport Department
    (MGRTD) was inaugurated with 120 buses on 12th September 1948.`,
    [HS_P2]: `The State Transport, which wasbeing administered as a Department of the
    Govt. of Mysore was subsequently converted into an independent
    Corporation under Section 3 of the Road TransportCorporation Act,1950 on
    1st of August 1961. The assets and liabilities of MGRTD except those
    ofBTS unit as on 01-08-1961 were passed on to the new Corporation,
    whichwas named as MSRTC. The assets and liabilities of the residual
    MGRTD i.e. of BTS Unit were subsequently passed on to the Corporation on
    1st of October1961. Thus, a Corporation was ultimately established for
    the entire State of Mysore.`,
    [HS_P3]: `At the beginning, the passengertransport services were operated in 6
    Divisions - 5 Divisions operating mofussilservices and 1 Division
    operating city services of Bangalore. It had 37 Depots,2 Regional
    Workshops and a Central Office at Bangalore. There were 15 permanentand
    30 temporary bus stations with 35 ways ide shelters and 104 pick- up
    shelters. The total numberof emplo yeesdeployed was 9705 and the s
    taffratio per s chedule was 9.43. The totalnumber of routes operated was
    1065 with 1029 schedules and route length of 32,134 miles, average daily
    scheduledmileage being 127571. The total number ofinter-state routes
    operated by the Corporation on a reciprocal basis with theneighbouring
    States were 40 ie., 29 in Maharashtra, 1 in Goa, 7 in AndhraPradesh, 2
    in Tamilnadu and 1 in Kerala. The total number of vehicles held was1518
    with average vehicleu tilisationof 123.8 miles. The average number of
    passengers carried per day was 4.35 lakh.The rate of breakdownwas 1.88
    and that of accident was 1.19. Earning per Mile (E PM ) realized was
    161.6 Ps. , and Cost per Mile ( CPM ) was 127.2 Ps. , resulting in net
    profit margin of 34.4Ps/mile.`,
    [GAPK_TITLE]: "Growth and Progress of KSRTC:",
    [GAPK_P1]: `Along with the rapid progressof Karnataka in all spheres of activity ,
    KSRTC has emerged as the best organisationin meeting the aspirations of
    Kannadigas and the people of neighbouring statesof Karnataka. As at the
    end of 31-03-1997 , the Corporation operated its servicesin 19 Divisions
    - 17Divisions operating mofussil services and 2 Division operating city
    services ofBangalore. It had 108 Depots, 2 Regional Workshops and a
    Central Office atBangalore. There were 281 permanent and 11 temporary
    bus stations with 337 wayside shelters and1009 pick- upshelters. The
    total number of employees deployed was 59033 and the s taff ratio per s
    chedule was 6.22. The totalnumber of routes operated wa s13273 with 9493
    schedules, routelength of 9.49 lakh Kms. and average daily scheduled kms
    of 31.61 lakh kms. Thetotal number of inter-state routes operated by the
    Corporation on a reciprocalbasis with the neighbouring states were 602
    ie., 282 in Maharashtra, 37 in Goa,223 in Andhra Pradesh, 33 in
    Tamilnadu and 27 in Kerala. The total number ofvehicles held was 10476
    with average v ehicle u tilisation of 299.6 Kms . The average number
    ofpassengers carried per day was 57.82 lakh. The rate of b reakdown was
    0.23 and the rate of a ccident was 0.22. EPKM realized was807.3 Ps. and
    CPKM was 975.4 Ps. , resulting in net loss margin of 168.1 Ps./Km. on
    traffic revenue.`,
    [BOK_TITLE]: "Bifurcation of KSRTC:",
    [BOK_P1]: `To increase operationalefficiency, to provide quality transport service
    to the traveling public and tohave an effective supervision on the
    operations of the Corporation , the Government of Karnatakaordered for
    bifurcation of KSRTC into 4 separate Corporation s vide its order No.HTD
    127 TRA96 dated 22-02-1997.`,
    [BOK_P2]: `Thus, KSRTC was a monolithic State Road TransportUndertaking till
    1996-97. Thereafter, duringthe year 1997-98, the State Government
    divided KSRTC and carved out two newCorporations, viz., the
    BangaloreMetropolitan Transport Corporation (BMTC) with its corporate
    office at Bangalore and the North West Karnataka Road
    TransportCorporation, withits corporate office at Hubli. The Bangalore
    Metropolitan TransportCorporation which came into being on 15-08-1997
    caters exclusively to the cityof Bangalore. And the North WestKarnataka
    Road Transport Corporation which came into being with effect from
    01-11-1997 caters to the northwestern districts of Karnataka. NWKRTC
    became financially independent w.e.f. 01-04-1998 under RTC Act 1982. One
    more new Corporation called the North East Karnataka Road
    TransportCorporation was also established with effectfrom 15-08-2000
    with its h ead q uarters at Gulbarga to cater to the northeastern
    districts of Karnataka, which beca me financially independent w.e.f.
    01-10-2000.`,
    [RSO_TITLE]: "Restructured STU Operations",
    [PS_TITLE]: "Present Status&nbsp;(Month of Nov-2020):",
    [PS_P1]: `KSRTC has its Corporate office atBangalore. Presently, it covers
    seventeen Districts (Bangalore Urban, BangaloreRural, Ramanagar, Kolar,
    Chickballapur, Tumkur, Chitradurga, Davanagere, Shivamogga,Mangalore,
    Udupi, Chickmagalur, Hassan, Mysore, Mandya, Chamarajnagar, Coorg) inthe
    State under its operational jurisdiction. The Corporation functions in 3
    –tier system, i.e., Corporate office, Division office and Depots. There
    are totally17 Divisions - 16 operating Divisions viz. Bangalore Central,
    Ramanagar, Tumkur, Kolar, Chickballapur,Mysore City, Mysore Rural,
    Mandya, Chamarajnagar, Hassan, Chickmagalur,Mangalore, Puttur,
    Davanagere, Shivamogga, Chitradurga and 1 bus station divisionviz.,
    Kempegowda Bus Station at Bangalore. There are 83 Depots, 2 Regional
    Workshops, 1Central Training Institute, 4 Regional Training Institutes,
    1 Printing Pressand 1 Hospital. KSRTC has a workforce of about 37618
    employees. It operates on an average 20.67 lakh kms daily with a fleet
    sizeof 8492 vehiclesand earns trafficrevenue of Rs. 630.53 lakh daily by
    catering to 13.66 lakh passengers on an average.It stands 5th amongst
    STUs in the nation by size.`,
  },
  kn: {
    [HS_TITLE]: "KSRTC ಇತಿಹಾಸ",
    [HS_P1]: `ಹಿಂದೆ ಮೈಸೂರು ರಾಜ್ಯದ ಸಾರ್ವಜನಿಕರು ಪ್ರಯಾಣಿಸುವ ಸಲುವಾಗಿ ಸಾರಿಗೆ ಅಗತ್ಯಗಳನ್ನು ಪೂರೈಸಲು, ಮೈಸೂರು
    ಸರ್ಕಾರಿ ರಸ್ತೆ ಸಾರಿಗೆ ಇಲಾಖೆಯನ್ನು (MGRTD) 1948 ರ ಸೆಪ್ಟೆಂಬರ್ 12 ರಂದು 120 ಬಸ್‌ಗಳೊಂದಿಗೆ ಉದ್ಘಾಟಿಸಲಾಯಿತು.`,
    [HS_P2]: `ಮೈಸೂರು ಸರ್ಕಾರದ ಇಲಾಖೆಯಾಗಿ ಆಡಳಿತ ನಡೆಸುತ್ತಿದ್ದ ರಾಜ್ಯ ಸಾರಿಗೆ, 1961 ರ ಆಗಸ್ಟ್ 1 ರಂದು ರಸ್ತೆ ಸಾರಿಗೆ ನಿಗಮ
    ಕಾಯಿದೆ, 1950 ರ ಸೆಕ್ಷನ್ 3 ರ ಅಡಿಯಲ್ಲಿ ಸ್ವತಂತ್ರ ನಿಗಮವಾಗಿ ಬದಲಾವಣೆಯಾಯಿತು. 01-08-1961 ರಂದು BTS
    ಸಂಸ್ಥೆಯನ್ನು ಹೊರತುಪಡಿಸಿ MGRTD ಯ ಆಸ್ತಿಗಳು ಮತ್ತು ಸಾಲಗಳನ್ನು ಹೊಸ ನಿಗಮಕ್ಕೆ ವರ್ಗಾಯಿಸಲಾಯಿತು, ಇದನ್ನು
    MSRTC ಎಂದು ಹೆಸರಿಸಲಾಯಿತು. ಉಳಿದ MGRTD ಅಂದರೆ BTS ಸಂಸ್ಥೆಯ ಸ್ವತ್ತುಗಳು ಮತ್ತು ಸಾಲಗಳನ್ನು ನಂತರ
    ಅಕ್ಟೋಬರ್ 1, 1961 ರಂದು ನಿಗಮಕ್ಕೆ ವರ್ಗಾಯಿಸಲಾಯಿತು. ಹೀಗಾಗಿ, ಅಂತಿಮವಾಗಿ ಇಡೀ ಮೈಸೂರು ರಾಜ್ಯಕ್ಕೆ ನಿಗಮವನ್ನು
    ಸ್ಥಾಪಿಸಲಾಯಿತು.`,
    [HS_P3]: `ಆರಂಭದಲ್ಲಿ, ಪ್ರಯಾಣಿಕ ಸಾರಿಗೆ ಸೇವೆಗಳನ್ನು 6 ವಿಭಾಗಗಳಲ್ಲಿ ನಿರ್ವಹಿಸಲಾಗುತ್ತಿತ್ತು - 5 ವಿಭಾಗಗಳು ಗ್ರಾಮೀಣ ಪ್ರದೇಶದ
    ಸೇವೆಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತವೆ ಮತ್ತು 1 ವಿಭಾಗವು ಬೆಂಗಳೂರಿನ ನಗರ ಸೇವೆಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತದೆ. ಇದು 37 ಡಿಪೋಗಳು, 2
    
    ಪ್ರಾದೇಶಿಕ ಕಾರ್ಯಾಗಾರಗಳು ಮತ್ತು ಬೆಂಗಳೂರಿನಲ್ಲಿ ಕೇಂದ್ರ ಕಚೇರಿಯು ಇತ್ತು. 15 ಶಾಶ್ವತ ಮತ್ತು 30 ತಾತ್ಕಾಲಿಕ ಬಸ್
    ನಿಲ್ದಾಣಗಳು 35 ಮಾರ್ಗಪಕ್ಕದಲ್ಲಿ ತಂಗುದಾಣಗಳಿದ್ದವು ಮತ್ತು104 ಪಿಕ್-ಅಪ್ (ಜನರು ಹತ್ತುವ) ತಂಗುದಾಣಗಳಿದ್ದವು.
    ನಿಯೋಜಿಸಲಾದ ಒಟ್ಟು ಉದ್ಯೋಗಿಗಳ ಸಂಖ್ಯೆ 9705 ಮತ್ತು ಪ್ರತಿ ವೇಳಾಪಟ್ಟಿಗೆ ಸಿಬ್ಬಂದಿ ಅನುಪಾತವು 9.43 ಆಗಿತ್ತು. ಒಟ್ಟು
    1029 ವೇಳಾಪಟ್ಟಿಗಳೊಂದಿಗೆ 1065 ಮಾರ್ಗಗಳು ಮತ್ತು ಮಾರ್ಗದ ಉದ್ದ 32,134 ಮೈಲುಗಳು, ಸರಾಸರಿ ಪ್ರತಿದಿನದ ನಿಗದಿತ
    ಮೈಲೇಜ್ 127571. ನಿಗಮದ ನೆರೆಯ ರಾಜ್ಯಗಳೊಂದಿಗೆ ಪರಸ್ಪರ ಆಧಾರದ ಮೇಲೆ ನಿರ್ವಹಿಸುವ ಒಟ್ಟು ಅಂತರ-ರಾಜ್ಯ
    ಮಾರ್ಗಗಳ ಸಂಖ್ಯೆ 40 ಅಂದರೆ., 29 ಮಹಾರಾಷ್ಟ್ರದಲ್ಲಿ, ಗೋವಾದಲ್ಲಿ 1, ಆಂಧ್ರಪ್ರದೇಶದಲ್ಲಿ 7, ತಮಿಳುನಾಡಿನಲ್ಲಿ 2 ಮತ್ತು
    ಕೇರಳದಲ್ಲಿ 1. ಸರಾಸರಿ ವಾಹನ ಬಳಕೆ 123.8 ಮೈಲುಗಳೊಂದಿಗೆ ಒಟ್ಟು 1518 ವಾಹನಗಳು ಕೆಲಸ ಮಾಡಿವೆ. ದಿನಕ್ಕೆ ಸಾಗಿಸುವ
    ಸರಾಸರಿ ಪ್ರಯಾಣಿಕರ ಸಂಖ್ಯೆ 4.35 ಲಕ್ಷ. ಸ್ಥಗಿತದ ಪ್ರಮಾಣ 1.88 ಮತ್ತು ಅಪಘಾತದ ಪ್ರಮಾಣ 1.19. ಪ್ರತಿ ಮೈಲಿಗೆ ಗಳಿಕೆ (E
    PM ) 161.6ಪೈಸೆ ಆಗಿತ್ತು, ಮತ್ತು ಪ್ರತಿ ಮೈಲಿಗೆ ವೆಚ್ಚ (CPM) 127.2 ಪೈಸೆ, 34.4ಪೈಸೆ/ಮೈಲಿ ನಿವ್ವಳ ಲಾಭಾಂಶಕ್ಕೆ
    ಕಾರಣವಾಗುತ್ತದೆ.`,
    [GAPK_TITLE]: "KSRTC ಯ ಬೆಳವಣಿಗೆ ಮತ್ತು ಪ್ರಗತಿ:",
    [GAPK_P1]: `ಎಲ್ಲಾ ಕ್ಷೇತ್ರಗಳ ಚಟುವಟಿಕೆಯಲ್ಲಿ ಕರ್ನಾಟಕದ ತ್ವರಿತ ಪ್ರಗತಿಯೊಂದಿಗೆ, KSRTC ಕನ್ನಡಿಗರ ಮತ್ತು ಕರ್ನಾಟಕದ ನೆರೆಯ ರಾಜ್ಯಗಳ
    ಜನರ ಆಕಾಂಕ್ಷೆಗಳನ್ನು ಪೂರೈಸುವಲ್ಲಿ ಅತ್ಯುತ್ತಮ ಸಂಸ್ಥೆಯಾಗಿ ಹೊರಹೊಮ್ಮಿದೆ. 31-03-1997 ರ ಅಂತ್ಯದ ವೇಳೆಗೆ, ಕಾರ್ಪೊರೇಷನ್
    ತನ್ನ ಸೇವೆಗಳನ್ನು 19 ವಿಭಾಗಗಳಲ್ಲಿ ನಿರ್ವಹಿಸಿತು - 17 ವಿಭಾಗಗಳು ಗ್ರಾಮೀಣ ಪ್ರದೇಶದ ಸೇವೆಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತವೆ ಮತ್ತು 2
    ವಿಭಾಗವು ಬೆಂಗಳೂರಿನ ನಗರ ಸೇವೆಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತದೆ. ಇದು 108 ಡಿಪೋಗಳು, 2 ಪ್ರಾದೇಶಿಕ ಕಾರ್ಯಾಗಾರಗಳು ಮತ್ತು
    ಬೆಂಗಳೂರಿನಲ್ಲಿ ಕೇಂದ್ರ ಕಚೇರಿಯನ್ನು ಹೊಂದಿತ್ತು. 337 ತಂಗುದಾಣಗಳು ಮತ್ತು 1009 ಪಿಕ್-ಅಪ್ (ಹತ್ತಿಕೊಳ್ಳುವ)
    ತಂಗುದಾಣಗಳೊಂದಿಗೆ 281 ಶಾಶ್ವತ ಮತ್ತು 11 ತಾತ್ಕಾಲಿಕ ಬಸ್ ನಿಲ್ದಾಣಗಳಿವೆ. ನಿಯೋಜಿಸಲಾದ ಒಟ್ಟು ಉದ್ಯೋಗಿಗಳ ಸಂಖ್ಯೆ
    59033 ಮತ್ತು ಪ್ರತಿ ವೇಳಾಪಟ್ಟಿಗೆ ಸಿಬ್ಬಂದಿ ಅನುಪಾತವು 6.22 ಆಗಿತ್ತು. 9493 ವೇಳಾಪಟ್ಟಿಗಳೊಂದಿಗೆ ಒಟ್ಟು 13273
    ಮಾರ್ಗಗಳನ್ನು ನಿರ್ವಹಿಸಲಾಗಿದೆ, ಮಾರ್ಗದ ಉದ್ದ 9.49 ಲಕ್ಷ ಕಿ.ಮೀ. ಮತ್ತು ಸರಾಸರಿ ಪ್ರತಿದಿನದ ನಿಗದಿತ ಕಿ.ಮೀಗಳು 31.61 ಲಕ್ಷ
    
    ಕಿ.ಮೀ. ನೆರೆಯ ರಾಜ್ಯಗಳೊಂದಿಗೆ ಪರಸ್ಪರ ಆಧಾರದ ಮೇಲೆ ನಿಗಮವು ನಿರ್ವಹಿಸುವ ಒಟ್ಟು ಅಂತರ-ರಾಜ್ಯ ಮಾರ್ಗಗಳ ಸಂಖ್ಯೆ 602
    ಅಂದರೆ, ಮಹಾರಾಷ್ಟ್ರದಲ್ಲಿ 282, ಗೋವಾದಲ್ಲಿ 37, ಆಂಧ್ರಪ್ರದೇಶದಲ್ಲಿ 223, ತಮಿಳುನಾಡಿನಲ್ಲಿ 33 ಮತ್ತು ಕೇರಳದಲ್ಲಿ 27.
    ಒಟ್ಟು ವಾಹನಗಳ ಸಂಖ್ಯೆ 10476 ಆಗಿದ್ದು, ಸರಾಸರಿ ವಾಹನ ಬಳಕೆ 299.6 ಕಿ.ಮೀ. ದಿನಕ್ಕೆ ಸಾಗಿಸುವ ಸರಾಸರಿ ಪ್ರಯಾಣಿಕರ ಸಂಖ್ಯೆ
    57.82 ಲಕ್ಷ. ಸ್ಥಗಿತದ ಪ್ರಮಾಣ 0.23 ಮತ್ತು ಅಪಘಾತದ ಪ್ರಮಾಣ 0.22 ಆಗಿತ್ತು. EPKM 807.3 ಪೈಸೆ ಎಂದು ಅರಿತುಕೊಂಡಿದೆ.
    ಮತ್ತು CPKM 975.4ಪೈಸೆ ಆಗಿತ್ತು. , ಇದರ ಪರಿಣಾಮವಾಗಿ ಸಂಚಾರ ಆದಾಯದ ಮೇಲೆ 168.1 ಪೈಸೆ./ಕಿ.ಮೀ. ನಿವ್ವಳ ನಷ್ಟದ
    ಮಾರ್ಜಿನ್.`,
    [BOK_TITLE]: "KSRTC ವಿಭಜನೆ:",

    [BOK_P1]: `ಕೆಲಸದ ಸಾಮರ್ಥ್ಯವನ್ನು ಹೆಚ್ಚಿಸಲು, ಪ್ರಯಾಣಿಸುವ ಸಾರ್ವಜನಿಕರಿಗೆ ಗುಣಮಟ್ಟದ ಸಾರಿಗೆ ಸೇವೆಯನ್ನು ನೀಡಲು ಮತ್ತು ನಿಗಮದ
    ಕಾರ್ಯಾಚರಣೆಗಳ ಮೇಲೆ ಪರಿಣಾಮಕಾರಿ ಮೇಲ್ವಿಚಾರಣೆಯನ್ನು ಹೊಂದಲು, ಕರ್ನಾಟಕ ಸರ್ಕಾರವು KSRTC ಅನ್ನು 4 ಪ್ರತ್ಯೇಕ
    ನಿಗಮಗಳಾಗಿ ವಿಭಜಿಸಲು ಅದರ ಆದೇಶ ಸಂಖ್ಯೆ.HTD 127 TRA96, 22-02-1997 ದಿನಾಂಕದ ಆದೇಶದಂತೆ.`,
    [BOK_P2]: `ಹೀಗಾಗಿ, KSRTC 1996-97 ರವರೆಗೆ ಅವಿಭಾಜ್ಯ ರಾಜ್ಯ ರಸ್ತೆ ಸಾರಿಗೆ ಸಂಸ್ಥೆಯಾಗಿತ್ತು. ಅದರ ನಂತರ, 1997-98 ರಲ್ಲಿ, ರಾಜ್ಯ
    ಸರ್ಕಾರವು KSRTCಯನ್ನು ವಿಭಜಿಸಿ ಎರಡು ಹೊಸ ನಿಗಮಗಳನ್ನು ರಚಿಸಿತು, ಅವುಗಳೆಂದರೆ ಬೆಂಗಳೂರು ಮಹಾನಗರ ಸಾರಿಗೆ ಸಂಸ್ಥೆ
    (BMTC) ಬೆಂಗಳೂರಿನಲ್ಲಿ ಅದರ ಕಾರ್ಪೊರೇಟ್ ಕಚೇರಿ ಮತ್ತು ವಾಯುವ್ಯ ಕರ್ನಾಟಕ ರಸ್ತೆ ಸಾರಿಗೆ ನಿಗಮ, ಹುಬ್ಬಳ್ಳಿಯಲ್ಲಿ ಅದರ
    ಕಾರ್ಪೊರೇಟ್ ಕಚೇರಿ ಇತ್ತು. 15-08-1997 ರಂದು ಅಸ್ತಿತ್ವಕ್ಕೆ ಬಂದ ಬೆಂಗಳೂರು ಮೆಟ್ರೋಪಾಲಿಟನ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್
    ಕಾರ್ಪೊರೇಷನ್ ಬೆಂಗಳೂರು ನಗರಕ್ಕೆ ಪ್ರತ್ಯೇಕವಾಗಿ ಸೇವೆ ಸಲ್ಲಿಸುತ್ತದೆ. ಮತ್ತು 01-11-1997 ರಿಂದ ಜಾರಿಗೆ ಬಂದ ವಾಯುವ್ಯ
    ಕರ್ನಾಟಕ ರಸ್ತೆ ಸಾರಿಗೆ ನಿಗಮವು ಕರ್ನಾಟಕದ ವಾಯುವ್ಯ ಜಿಲ್ಲೆಗಳನ್ನು ಪೂರೈಸುತ್ತದೆ. NWKRTC ಆರ್ಥಿಕವಾಗಿ
    ಸ್ವತಂತ್ರವಾಯಿತು RTC ಕಾಯಿದೆ 1982 ರ ಅಡಿಯಲ್ಲಿ 01-04-1998 ರಿಂದ ಜಾರಿಗೆ ಬಂದಿತು. ಈಶಾನ್ಯ ಕರ್ನಾಟಕ ರಸ್ತೆ ಸಾರಿಗೆ
    ನಿಗಮ ಎಂಬ ಮತ್ತೊಂದು ಹೊಸ ನಿಗಮವನ್ನು ಸಹ 15-08-2000 ರಿಂದ ಜಾರಿಗೆ ಬರುವಂತೆ ಸ್ಥಾಪಿಸಲಾಯಿತು, ಅದರ ಕೇಂದ್ರ
    ಕಛೇರಿ ಗುಲ್ಬರ್ಗದಲ್ಲಿ ಕರ್ನಾಟಕದ ಈಶಾನ್ಯ ಜಿಲ್ಲೆಗಳನ್ನು ಪೂರೈಸಲು ಆರ್ಥಿಕವಾಗಿ 01-10-2000 ಇಂದಿನಿಂದ
    ಸ್ವತಂತ್ರವಾಯಿತು.`,

    [RSO_TITLE]: "ಪುನರ್ರಚಿಸಿದ STU ಕಾರ್ಯಗಳು",
    [PS_TITLE]: "ಇಂದಿನ ಸ್ಥಿತಿ (-2020 ರ ನವೆಂಬರ್ ತಿಂಗಳು):",
    [PS_P1]: `ಬೆಂಗಳೂರಿನಲ್ಲಿ KSRTC ಯ ಕಾರ್ಪೊರೇಟ್ ಕಚೇರಿ ಇದೆ. ಇಂದು, ಇದು ರಾಜ್ಯದ ಹದಿನೇಳು ಜಿಲ್ಲೆಗಳನ್ನು (ಬೆಂಗಳೂರು ನಗರ,
      ಬೆಂಗಳೂರು ಗ್ರಾಮಾಂತರ, ರಾಮನಗರ, ಕೋಲಾರ, ಚಿಕ್ಕಬಳ್ಳಾಪುರ, ತುಮಕೂರು, ಚಿತ್ರದುರ್ಗ, ದಾವಣಗೆರೆ, ಶಿವಮೊಗ್ಗ, ಮಂಗಳೂರು,
      ಉಡುಪಿ, ಚಿಕ್ಕಮಗಳೂರು, ಹಾಸನ, ಮೈಸೂರು, ಮಂಡ್ಯ, ಚಾಮರಾಜನಗರ, ಮಡಿಕೇರಿ) ತನ್ನ ಕಾರ್ಯವ್ಯಾಪ್ತಿಯ ಹೊಂದಿದೆ. ನಿಗಮವು 3-
      ಶ್ರೇಣಿಯ ವ್ಯವಸ್ಥೆಯಲ್ಲಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ, ಅಂದರೆ, ಕಾರ್ಪೊರೇಟ್ ಕಚೇರಿ, ವಿಭಾಗ ಕಚೇರಿ ಮತ್ತು ಡಿಪೋಗಳು. ಒಟ್ಟು 17
      ವಿಭಾಗಗಳಿವೆ - 16 ಕಾರ್ಯಾಚರಣಾ ವಿಭಾಗಗಳು ಅಂದರೆ. ಬೆಂಗಳೂರು ಸೆಂಟ್ರಲ್, ರಾಮನಗರ, ತುಮಕೂರು, ಕೋಲಾರ, ಚಿಕ್ಕಬಳ್ಳಾಪುರ,
      ಮೈಸೂರು ನಗರ, ಮೈಸೂರು ಗ್ರಾಮಾಂತರ, ಮಂಡ್ಯ, ಚಾಮರಾಜನಗರ, ಹಾಸನ, ಚಿಕ್ಕಮಗಳೂರು, ಮಂಗಳೂರು, ಪುತ್ತೂರು, ದಾವಣಗೆರೆ,
      ಶಿವಮೊಗ್ಗ, ಚಿತ್ರದುರ್ಗ ಮತ್ತು 1 ಬಸ್ ನಿಲ್ದಾಣ ವಿಭಾಗ, ಬೆಂಗಳೂರಿನ ಕೆಂಪೇಗೌಡ ಬಸ್ ನಿಲ್ದಾಣ. 83 ಡಿಪೋಗಳು, 2 ಪ್ರಾದೇಶಿಕ
      ಕಾರ್ಯಾಗಾರಗಳು, 1 ಕೇಂದ್ರ ತರಬೇತಿ ಸಂಸ್ಥೆ, 4 ಪ್ರಾದೇಶಿಕ ತರಬೇತಿ ಸಂಸ್ಥೆಗಳು, 1 ಮುದ್ರಣಾಲಯ ಮತ್ತು 1 ಆಸ್ಪತ್ರೆ ಇದೆ.
      KSRTCಯಲ್ಲಿ ಸುಮಾರು 37618 ನೌಕರರು ಇದ್ದಾರೆ. ಇದು 8492 ವಾಹನಗಳ ಪ್ರಮಾಣದಲ್ಲಿ ಪ್ರತಿದಿನ ಸರಾಸರಿ 20.67 ಲಕ್ಷ
      ಕಿಲೋಮೀಟರ್‌ಗಳಲ್ಲಿ ಕೆಲಸ ಮಾಡುತ್ತದೆ ಮತ್ತು ಸರಾಸರಿ 13.66 ಲಕ್ಷ ಪ್ರಯಾಣಿಕರಿಗೆ ಉಪಚರಿಸುವ ಮೂಲಕ ಪ್ರತಿದಿನ ರೂ.630.53
      ಲಕ್ಷ ಸಂಚಾರದಿಂದ ಆದಾಯವನ್ನು ಗಳಿಸುತ್ತದೆ. ಇದು ಗಾತ್ರದಲ್ಲಿ ರಾಷ್ಟ್ರದ STU ಗಳಲ್ಲಿ 5 ನೇ ಸ್ಥಾನದಲ್ಲಿದೆ.
      ಕೊನೆಯದಾಗಿ ನವೀಕರಿಸಿದ ದಿನಾಂಕ 21 01-02-2024 03:15 AM`,
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
